import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppConfigurationService } from '../../services/app.configuration.service';
import { AuthenticationService } from '@app/core';
import { NavService } from '../../services/nav.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { CallMonitorService } from '@projects/supervisor/src/app/services/call-monitor.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
    selector: 'app-center-selection',
    templateUrl: './center-selection.component.html',
    styleUrls: ['./center-selection.component.scss'],
})
export class CenterSelectionComponent implements OnInit, OnDestroy {
    campaignList: any = [];
    centerList: any = [];
    selectedCampaignId: string = '';
    selectedCenterId: string = '';
    campaignCode: string = '';
    centerId: string = '';
    campaignId: string = '';
    constructor(private appConfig: AppConfigurationService,
        private authService: AuthenticationService,
        public navService: NavService,
        private http: HttpClient,
        private callMonitorService: CallMonitorService,
        private toastService: ToastService

    ) {
        this.navService.onCenterTabChangeEvent$.subscribe(({ center, isTabSelection }) => {
            if (isTabSelection) {
                this.onCenterChange(center, isTabSelection);
            }
        })
    }

    // ngOnInit(): void {
    //     this.campaignList = [];
    //     const centers = this.authService.getAllAssignedCenters() ?? [];
    //     this.centerList = centers.map((center: any) => ({ Name: center.Description, Code: center.Code }));


    //     const center = this.authService.getCurrentCenter();
    //     if (center?.Selected) {
    //         this.selectedCenterId = center.Selected;
    //         this.centerId = this.selectedCenterId;
    //         const mapping = this.appConfig.getByIdentifier('CenterCampaignsMapping').Fields;
    //         let centerCampaignsMapping = mapping.find((m: any) => m.Center === center.Selected)?.Campaigns ?? [];
    //         let userCampaigns = this.authService.getAllAssignedCentersCampaign() ?? [];
    //         let campaigns = centerCampaignsMapping.filter((itemA: any) =>
    //             userCampaigns.some(itemB => itemB.Code === itemA.Code)
    //         );
    //         if (centers.length > 1)
    //             this.centerList.unshift({ Name: 'All', Code: '' });
    //         this.campaignList = campaigns;
    //         this.selectedCampaignId = center.CampaignId ?? '';
    //         this.campaignId = this.selectedCampaignId;
    //         this.campaignCode = campaigns.find((x: any) => x.Id === this.selectedCampaignId)?.Code ?? 'All';
    //     }
    //     else {
    //         const mapping = this.appConfig.getByIdentifier('CenterCampaignsMapping').Fields;
    //         const centerIds = centers.map((c: any) => c.Code);
    //         // let campaigns = mapping.filter((x: any) => centerIds.indexOf(x.Center) != -1).flatMap((f: any) => f.Campaigns) ?? [];
    //         let campaigns = this.authService.getAllAssignedCentersCampaign() ?? [];
    //         if (centers.length > 1) {
    //             this.centerList.unshift({ Name: 'All', Code: '' });
    //         }
    //         if(centers.length == 1) {
    //             this.selectedCenterId = centers[0].Code;
    //             this.centerId = this.selectedCenterId;
    //         }

    //         this.campaignList = campaigns;
    //         if (center.CampaignId) {
    //             this.selectedCampaignId = center.CampaignId;
    //             this.campaignId = this.selectedCampaignId;
    //             this.campaignCode = campaigns.find((x: any) => x.Id === this.selectedCampaignId)?.Code ?? 'All';
    //         }
    //     }
    //     this.navService.onCenterChangeEvent$.next({
    //         campaignId: this.selectedCampaignId,
    //         centerId: this.selectedCenterId,
    //         campaignCode: this.campaignCode,
    //         campaignList: this.campaignList,
    //         refresh: false
    //     });
    // }


    ngOnInit(): void {
        this.campaignList = [];
        const centers = this.authService.getAllAssignedCenters() ?? [];
        this.centerList = centers.map((center: any) => ({ Name: center.Description, Code: center.Code }));
        if (this.centerList.length > 1) {
            this.centerList.unshift({ Name: 'All', Code: '' });
        }
        const center = this.authService.getCurrentCenter();

        if (this.centerList.length == 1 && !center?.Selected) {
            center.Selected = this.centerList[0].Code;
        }

        if (center?.Selected) {
            this.selectedCenterId = center.Selected;
            this.centerId = this.selectedCenterId;
            const mapping = this.appConfig.getByIdentifier('CenterCampaignsMapping').Fields;
            let centerCampaignsMapping = mapping.find((m: any) => m.Center === center.Selected)?.Campaigns ?? [];
            let userCampaigns = this.authService.getAllAssignedCentersCampaign() ?? [];
            let campaigns = centerCampaignsMapping.filter((itemA: any) =>
                userCampaigns.some(itemB => itemB.Code === itemA.Code)
            );
            campaigns.unshift({ Id: '', Name: '', Code: 'All' });
            this.campaignList = campaigns;
            this.selectedCampaignId = center.CampaignId ?? '';
            this.campaignId = this.selectedCampaignId;
            this.campaignCode = campaigns.find((x: any) => x.Id === this.selectedCampaignId)?.Code ?? 'All';
        }
        else {
            let campaigns = this.authService.getAllAssignedCentersCampaign() ?? [];
            campaigns.unshift({ Id: '', Name: '', Code: 'All' });
            this.campaignList = campaigns;
            if (center.CampaignId) {
                this.selectedCampaignId = center.CampaignId;
                this.campaignId = this.selectedCampaignId;
                this.campaignCode = campaigns.find((x: any) => x.Id === this.selectedCampaignId)?.Code ?? 'All';
            }
        }
        this.navService.onCenterChangeEvent$.next({
            campaignId: this.selectedCampaignId,
            centerId: this.selectedCenterId,
            campaignCode: this.campaignCode,
            campaignList: this.campaignList,
            refresh: false
        });
    }
    ngOnDestroy(): void { }
    onCenterChange(centerid: string, isTabSelection: boolean = false) {
        const mapping = this.appConfig.getByIdentifier('CenterCampaignsMapping').Fields;
        let userCampaigns = this.authService.getAllAssignedCentersCampaign() ?? [];
        let campaigns = [];
        if (centerid) {
            campaigns = mapping.find((m: any) => m.Center === centerid)?.Campaigns ?? [];
            const result = campaigns.filter((itemA: any) =>
                userCampaigns.some(itemB => itemB.Code === itemA.Code)
            );
            campaigns = result;
        }
        else {
            // const centers = this.authService.getAllAssignedCenters() ?? [];
            // const centerIds = centers.map((c: any) => c.Code);
            // campaigns = mapping.filter((x: any) => centerIds.indexOf(x.Center) != -1).flatMap((f: any) => f.Campaigns) ?? [];
            campaigns = userCampaigns;
        }
        campaigns.unshift({ Id: '', Name: '', Code: 'All' });
        this.campaignList = campaigns;
        this.selectedCenterId = centerid;
        setTimeout(() => {
            this.selectedCampaignId = '';
            if (isTabSelection) {
                this.onSave(centerid, isTabSelection);
            }
        }, 50);
    }
    onSelectedCampaignChange(campaignid: string) {
        if (campaignid == null) return;
        this.selectedCampaignId = campaignid;
    }
    onCancel() {
        const center = this.authService.getCurrentCenter();
        this.selectedCenterId = center.Selected ?? '';
        this.selectedCampaignId = center.CampaignId ?? '';
        this.navService.toggleLocationDrawer();
    }
    onSave(center: string = '', isTabSelection: boolean = false) {

        if (this.callMonitorService.isMonitoring) {
            this.toastService.info("Cannot change location while call monitoring is active.");
            return;
        }
        const url = `/user/update-selected-location`;
        if (isTabSelection) {
            this.selectedCenterId = center;
        }
        const body = { CenterId: this.selectedCenterId, CampaignId: this.selectedCampaignId };
        this.http.put(url, body).subscribe({
            next: () => {
                this.centerId = this.selectedCenterId;
                this.campaignId = this.selectedCampaignId;
                this.campaignCode = this.campaignList.find((x: any) => x.Id === this.selectedCampaignId)?.Code ?? 'All';
                this.authService.updateCenterAndCampaign(this.selectedCenterId, this.selectedCampaignId);
                this.navService.onCenterChangeEvent$.next({
                    campaignId: this.selectedCampaignId,
                    centerId: this.selectedCenterId,
                    campaignCode: this.campaignCode,
                    campaignList: this.campaignList,
                    refresh: true
                });
                if (!isTabSelection) {
                    this.navService.toggleLocationDrawer();
                }
            },
            error: ({ error }) => {
                console.error(error);
            },
        });
    }
}
